import { render, staticRenderFns } from "./ClimbAngleFields.vue?vue&type=template&id=007130c6&"
import script from "./ClimbAngleFields.vue?vue&type=script&lang=ts&"
export * from "./ClimbAngleFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClimbAngleFields.vue"
export default component.exports